import { Label, Loader, MenuItem } from '@mairistem/composants';
import _ from 'lodash';
import type React from 'react';

type TabPaneHeaderProps = {
  id: string;
  name: string | React.ReactNode;
  count?: number | null;
  loading?: boolean;
};

/**
 * Composant utilisé pour l'affichage des Tab avec un chiffre avant le titre de l'onglet.
 *
 * @param props
 * @returns
 */
const TabPaneHeader = (props: TabPaneHeaderProps) => {
  const { id, name, count, loading = false, ...rest } = props;

  return (
    <MenuItem
      key={id}
      data-testid={`onglet-${id}`}
      style={{
        flex: 1,
        textAlign: 'center',
        alignSelf: 'stretch',
        justifyContent: 'center',
      }}
      disabled={loading}
      {...rest}
    >
      {loading && <Loader size="small" active inline style={{ marginRight: 10 }} />}
      {!loading && !_.isNil(count) && (
        <Label size="big" style={{ marginRight: 10 }}>
          {count}
        </Label>
      )}
      {name}
    </MenuItem>
  );
};

export default TabPaneHeader;
